/* eslint-disable react-refresh/only-export-components --
 * Context module: Provider + hook are intentionally co-located.
 */
import { createContext, useContext, type ReactNode } from 'react';

/** Set when `radio-option` cells share a table-row `RadioGroup` wrapper. */
const BespokeRadioRowContext = createContext(false);

export function BespokeRadioRowProvider({ children }: { children: ReactNode }) {
  return (
    <BespokeRadioRowContext.Provider value={true}>
      {children}
    </BespokeRadioRowContext.Provider>
  );
}

export function useBespokeRadioRowGroup(): boolean {
  return useContext(BespokeRadioRowContext);
}
